/* unplugin-vue-components disabled */import script from "./SalesmanPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesmanPoints.vue?vue&type=script&setup=true&lang=js"

import "./SalesmanPoints.vue?vue&type=style&index=0&id=b594018a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b594018a"]])

export default __exports__